const options = {
  5: "bg-sky-500/5",
  10: "bg-sky-500/10",
  25: "bg-sky-500/25",
  50: "bg-sky-500/50",
  75: "bg-sky-500/75",
  90: "bg-sky-500/90",
  100: "bg-sky-500",
};

const from = {
  5: "from-sky-500/5",
  10: "from-sky-500/10",
  25: "from-sky-500/25",
  50: "from-sky-500/50",
  75: "from-sky-500/75",
  90: "from-sky-500/90",
  100: "from-sky-500",
};

export default function getBackgroundSky500(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
